import { render, staticRenderFns } from "./HelpdeskMyTicketsView.vue?vue&type=template&id=9277d2ea"
import script from "./HelpdeskMyTicketsView.vue?vue&type=script&lang=js"
export * from "./HelpdeskMyTicketsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports